import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";
import { PlacementAccessControlStatus } from "../FeatureFlags/CbhFeatureFlags";

export function useGetPlacementsAccessLevel() {
  const flagValue = useCbhFlag(CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT, {
    defaultValue: PlacementAccessControlStatus.OFF,
  });
  return {
    isEnabled:
      flagValue === PlacementAccessControlStatus.EDIT_PAID ||
      flagValue === PlacementAccessControlStatus.EDIT_FREE ||
      flagValue === PlacementAccessControlStatus.VIEW,
    accessLevel: flagValue,
  };
}

interface CanCreateOrEditPlacementsParams {
  accessLevel: PlacementAccessControlStatus;
  admin: boolean;
  isManagedByParentWorkplace: boolean;
}

export function getCanCreateOrEditPlacements(params: CanCreateOrEditPlacementsParams) {
  const { accessLevel, admin, isManagedByParentWorkplace } = params;

  return (
    (!isManagedByParentWorkplace &&
      (accessLevel === PlacementAccessControlStatus.EDIT_PAID ||
        accessLevel === PlacementAccessControlStatus.EDIT_FREE)) ||
    admin
  );
}

export function shouldShowAdminPlacementsViewOnlyNotice(params: {
  accessLevel: PlacementAccessControlStatus;
  admin: boolean;
}) {
  return params.accessLevel === PlacementAccessControlStatus.VIEW && params.admin;
}
